import { render } from "./InfoCliente.vue?vue&type=template&id=fdc4f3ca&scoped=true"
import script from "./InfoCliente.vue?vue&type=script&lang=js"
export * from "./InfoCliente.vue?vue&type=script&lang=js"

import "./InfoCliente.vue?vue&type=style&index=0&id=fdc4f3ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc4f3ca"]])

export default __exports__